import "../styles/About.css"
import profile from "../assets/about_profile.webp"
import Marquee from "react-fast-marquee";
import Footer from "../components/Footer";

const About = () => {
  return (
    <div>
      <div className="about_section">
        <div className="head">
          <h1><span>Visual</span></h1>
          <h1>Art director</h1>
          <p>As a video and motion design specialist, I craft stunning visuals that tell the story of your brand in a captivating way. <span>Explore ↓</span></p>
        </div>
        <div className="about_profile">
          <img src={profile} alt="" />
          <div>
            <h1>Sasuke Yanai</h1>
            <p>VISUAL ART DIRECTOR</p>
          </div>
        </div>
        {/* Experience */}

        <div className="award_container about_award_container">
          <div>
            <h1>Experience</h1>
          </div>
          <div className="award_box about_award_box">
            <div className="award_content about_award_content">
              <div>
                {/* <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccc7d48c9f09c3ea7561_icon-01.svg"
                  alt=""
                /> */}
                <h2>VISUAL ART DIRECTOR</h2>
              </div>
              <span>2022 - NOW</span>
            </div>
            <div className="award_content about_award_content">
              <div>
                {/* <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccd213c113c80ba9c6f_icon-02.svg"
                  alt=""
                /> */}
                <h2>VIDEO DIRECTOR</h2>
              </div>
              <span>2020 - 2022</span>
            </div>
            <div className="award_content about_award_content">
              <div>
                {/* <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccce81a8e677df9db833_icon-03.svg"
                  alt=""
                /> */}
                <h2>VIDEO & ART DIRECTOR</h2>
              </div>
              <span>2018 - 2020</span>
            </div>
            <div className="award_content about_award_content">
              <div>
                {/* <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccef386b74850e95ae6_icon-04.svg"
                  alt=""
                /> */}
                <h2>VIDEO CUTTER</h2>
              </div>
              <span>2017 - 2018</span>
            </div>
          </div>
        </div>

        {/* Award Marquee */}

        <Marquee>
        <h1 className="marquee_work">
            <span>&nbsp; awards </span> awards{" "}
            <span> awards </span> awards{" "}
          </h1>
        </Marquee>

        {/* Motion Awards */}

        <div className="award_container about_award_container">
          <div>
            <h1>awards</h1>
          </div>
          <div className="award_box">
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccc7d48c9f09c3ea7561_icon-01.svg"
                  alt=""
                />
                <h2>video award</h2>
              </div>
              <span>2022</span>
            </div>
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccd213c113c80ba9c6f_icon-02.svg"
                  alt=""
                />
                <h2>MOTION DESIGNER OF THE YEAR</h2>
              </div>
              <span>2021</span>
            </div>
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638eccce81a8e677df9db833_icon-03.svg"
                  alt=""
                />
                <h2>VIDEO OF THE MONTH</h2>
              </div>
              <span>2019</span>
            </div>
            <div className="award_content">
              <div>
                <img
                  src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ecccef386b74850e95ae6_icon-04.svg"
                  alt=""
                />
                <h2>ART DIRECTION AWARD</h2>
              </div>
              <span>2018</span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default About